module.exports = __webpack_public_path__ + "static/img/pic_shujukq.633de25d.png";